import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  billType: "DINEIN",
  customer: null,
  defaultCustomer: null,
  btnClicked: null,
  aggregator: null,
  selectedDevice: null,
  customerWallet: null,
  searchBarInput:null,
  waiter:null,
  aggregatorRef:null,
  customerSingleInfo:null,
  customerTextfieldInput:"",
  customerLoading:false,
  customerSearchTerm:"",
  onGoingOrderCount:0,
  deliveryBoy:null
};

export const topBarSliceBilling = createSlice({
  name: "topBarSliceBilling",
  initialState,

  reducers: {
    setBillType: (state, action) => {
      state.billType = action.payload;
    },
    setCustomer: (state, action) => {
      state.customer = action.payload;
    },
    setSelectedDevice: (state, action) => {
      state.selectedDevice = action.payload || null;
    },
    setDefaultCustomer: (state, action) => {
      state.defaultCustomer = action.payload;
    },
    setBtnSelected:(state,action)=>{
      state.btnClicked=action.payload;
    },
    setAggregator: (state, action) => {
      state.aggregator = action.payload ? { 
        ...action.payload,
        aggregatorCategoryId: action.payload.aggregatorCategoryId || []
      } : null;
    },
    setAggregatorRef:(state,action)=>{
      state.aggregatorRef=action.payload;
    },
    setCustomerWallet:(state,action)=>{
      state.customerWallet=action.payload;
    },
    setSearchBarInput:(state,action)=>{
      state.searchBarInput=action.payload;
    },
    setOrderWaiter:(state,action)=>{
      state.waiter=action.payload;
    },
    setSingleCusInfo:(state,action)=>{
      state.customerSingleInfo=action.payload;
    },
    setCustomerTextfieldInput:(state,action)=>{
      state.customerTextfieldInput=action.payload;
    },
    setCustomerLoading:(state,action)=>{
      state.customerLoading=action.payload;
    },
    setCustomerSearchTerm:(state,action)=>{
      state.customerSearchTerm=action.payload;
    },
    setOngoingOrderCount:(state,action)=>{
      state.onGoingOrderCount=action.payload;
    },
    setSelfDeliveryKm:(state,action)=>{
      state.selfDeliveryKm = action.payload;
    },
    setSelfDeliveryCharge:(state,action)=>{
      state.selfDeliveryCharge = action.payload;
    },
    setDeliveryBoy:(state,action)=>{
      state.deliveryBoy = action.payload;
    },
    resetTopBarStates: () => initialState 
  }
});

export const {setOngoingOrderCount,setBillType,setCustomerLoading,setCustomerTextfieldInput,setCustomer,setSingleCusInfo,setOrderWaiter,setBtnSelected,setDefaultCustomer,setAggregatorRef,setAggregator,setCustomerWallet,setSelectedDevice,resetTopBarStates,setSearchBarInput,setCustomerSearchTerm,setSelfDeliveryKm,setSelfDeliveryCharge,setDeliveryBoy} = topBarSliceBilling.actions;

export default topBarSliceBilling.reducer;
